<div class="titre-bandeau">
    {{ label | uppercase | translate}}
</div>
